import {Utils} from "../utils";

export class DeviderRenderer{
	constructor(private container:HTMLElement){
	}

	public render(date:Date,shouldDisplay:boolean){
		var entryHtml = document.createElement("div");
		var monthHtml = document.createElement("div");

		entryHtml.classList.add("_monthHeader");
		monthHtml.classList.add("monthMedium");
		monthHtml.classList.add("_monthDevider");

		if(!shouldDisplay){
			entryHtml.style.display = "none";
		}

		monthHtml.innerHTML = Utils.monthNames[date.getMonth()] + " " + date.getFullYear();
		entryHtml.appendChild(monthHtml);
		this.container.appendChild(entryHtml);
	}
}